/* ============================================================
   DOGS SUPREME · <ds-nav-protokoll>
   Ausschlussdiaet-Begleiter: Wochen-Tracker (Navigator P6,
   docs/navigator-plattform.md).

   HARTE REGEL: Dieses Modul verkauft NICHTS (keine Bridge, kein
   Produkt). Es begleitet die tieraerztlich gefuehrte Ausschlussdiaet:
   Startdatum + Dauer (die Praxis gibt den Rahmen vor, haeufig 8 bis
   12 Wochen) -> Wochenzaehler + Resttage + Druck. localStorage
   ds_nav_protokoll_v1, sonst nichts.

   UI-Schicht: assets/ds-nav-foundation.css (.dsn-*), Spec
   docs/standards/navigator-design-spec.md. Nach dem Speichern wird
   der Button sekundaer ("Zeitraum aendern"), der Fokus liegt auf der
   Fortschritts-Karte.
   Kompatibilitaet wie ds-audio.js. Pure Funktionen Node-testbar.
   ============================================================ */
(function () {
  'use strict';

  function parseIso(iso) {
    var p = String(iso || '').split('-');
    if (p.length !== 3) return null;
    var d = new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
    return isNaN(d.getTime()) ? null : d;
  }

  /* Fortschritt: Woche (1-basiert), Tag im Protokoll, Resttage, fertig? */
  function progress(startIso, weeks, todayIso) {
    var start = parseIso(startIso), today = parseIso(todayIso);
    if (!start || !today || !(weeks >= 4 && weeks <= 16)) return null;
    var msPerDay = 24 * 60 * 60 * 1000;
    var dayIndex = Math.floor((today.getTime() - start.getTime()) / msPerDay);
    if (dayIndex < 0) return { notStarted: true, daysUntil: -dayIndex };
    var totalDays = weeks * 7;
    var week = Math.min(Math.floor(dayIndex / 7) + 1, weeks);
    var remaining = totalDays - dayIndex - 1;
    return {
      notStarted: false,
      week: week, weeks: weeks,
      day: Math.min(dayIndex + 1, totalDays),
      totalDays: totalDays,
      remaining: remaining > 0 ? remaining : 0,
      done: dayIndex + 1 >= totalDays,
      pct: Math.min(100, Math.round((dayIndex + 1) / totalDays * 100))
    };
  }

  function isoToday(now) {
    var d = now || new Date();
    var m = d.getMonth() + 1, day = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (day < 10 ? '0' + day : day);
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { progress: progress, isoToday: isoToday };
    return;
  }

  if (!('customElements' in window) || customElements.get('ds-nav-protokoll')) return;

  var LS_KEY = 'ds_nav_protokoll_v1';

  function ensureFoundation() {
    if (document.getElementById('dsn-foundation')) return;
    var probe = document.querySelector('link[href*="ds-nav-foundation"]');
    if (probe) { probe.id = probe.id || 'dsn-foundation'; return; }
    var self = document.querySelector('script[src*="ds-nav-protokoll"]');
    if (!self) return;
    var link = document.createElement('link');
    link.id = 'dsn-foundation';
    link.rel = 'stylesheet';
    link.href = self.src.split('?')[0].replace(/ds-nav-protokoll\.js$/, 'ds-nav-foundation.css');
    document.head.appendChild(link);
  }

  function injectStyles() {
    if (document.getElementById('ds-nav-protokoll-styles')) return;
    var style = document.createElement('style');
    style.id = 'ds-nav-protokoll-styles';
    style.textContent = [
      "ds-nav-protokoll .dspr-group{margin-bottom:14px}",
      "ds-nav-protokoll .dspr-state{display:none;margin-top:18px}",
      "ds-nav-protokoll .dspr-state.dspr-show{display:block}",
      "ds-nav-protokoll .dspr-week{font-size:26px;font-weight:700;color:#1d1d1f;letter-spacing:-.02em;margin:0 0 6px;font-variant-numeric:tabular-nums}",
      "ds-nav-protokoll .dspr-bar-wrap{margin:10px 0}",
      "ds-nav-protokoll .dspr-meta{font-size:13px;color:#6e6e73;margin:0;font-variant-numeric:tabular-nums}",
      "ds-nav-protokoll .dspr-actions{display:flex;gap:10px;flex-wrap:wrap;margin-top:14px}",
      "@media (max-width:480px){ds-nav-protokoll .dspr-actions{flex-direction:column;align-items:stretch}}",
      "@media print{body *{visibility:hidden}ds-nav-protokoll,ds-nav-protokoll *{visibility:visible}",
      "ds-nav-protokoll{position:absolute;left:0;top:0;width:100%}",
      "ds-nav-protokoll .dspr-actions,ds-nav-protokoll .dspr-save{display:none!important}",
      "ds-nav-protokoll .dsn-card{border:none;box-shadow:none;padding:0}}"
    ].join('');
    document.head.appendChild(style);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  class DsNavProtokoll extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      ensureFoundation();
      injectStyles();
      this.data = this.load() || { start: '', weeks: 10 };
      this.render();
    }

    load() {
      try { var raw = localStorage.getItem(LS_KEY); return raw ? JSON.parse(raw) : null; }
      catch (e) { return null; }
    }
    persist() { try { localStorage.setItem(LS_KEY, JSON.stringify(this.data)); } catch (e) {} }

    render() {
      var self = this;
      var card = el('div', 'dsn-card');
      card.appendChild(el('p', 'dsn-title', 'Dein Protokoll-Zeitraum'));
      card.appendChild(el('p', 'dsn-sub',
        'Deine Tierarztpraxis gibt Start und Dauer vor, häufig sind es 8 bis 12 Wochen. Trag beides ein, wir zählen mit.'));

      var g1 = el('div', 'dspr-group');
      var lbl = el('label', 'dsn-label', 'Startdatum');
      lbl.setAttribute('for', 'DsprStart');
      g1.appendChild(lbl);
      var input = el('input', 'dsn-input');
      input.id = 'DsprStart';
      input.type = 'date';
      input.value = this.data.start || '';
      g1.appendChild(input);
      var errLine = el('p', 'dsn-error-line', 'Bitte zuerst das Startdatum wählen.');
      errLine.style.display = 'none';
      g1.appendChild(errLine);
      card.appendChild(g1);
      this.input = input;
      this.errLine = errLine;

      var g2 = el('div', 'dspr-group');
      g2.appendChild(el('span', 'dsn-label', 'Dauer laut Praxis'));
      var segWrap = el('div', 'dsn-seg-track');
      [8, 10, 12].forEach(function (w) {
        var btn = el('button', 'dsn-seg', w + ' Wochen');
        btn.type = 'button';
        btn.setAttribute('aria-pressed', self.data.weeks === w ? 'true' : 'false');
        btn.addEventListener('click', function () {
          self.data.weeks = w;
          var all = segWrap.querySelectorAll('.dsn-seg');
          for (var i = 0; i < all.length; i++) all[i].setAttribute('aria-pressed', all[i] === btn ? 'true' : 'false');
        });
        segWrap.appendChild(btn);
      });
      g2.appendChild(segWrap);
      card.appendChild(g2);

      var btn = el('button', 'dsn-btn dspr-save', this.data.start ? 'Zeitraum ändern' : 'Zeitraum speichern');
      btn.type = 'button';
      btn.style.width = '100%';
      if (this.data.start) btn.classList.add('dsn-btn--ghost');
      card.appendChild(btn);
      this.saveBtn = btn;

      this.state = el('div', 'dspr-state');
      this.state.setAttribute('aria-live', 'polite');
      card.appendChild(this.state);

      btn.addEventListener('click', function () {
        if (!self.input.value) {
          self.errLine.style.display = 'block';
          self.input.focus();
          return;
        }
        self.errLine.style.display = 'none';
        self.data.start = self.input.value;
        self.persist();
        self.renderState();
        self.saveBtn.textContent = 'Zeitraum ändern';
        self.saveBtn.classList.add('dsn-btn--ghost');
      });
      input.addEventListener('input', function () { self.errLine.style.display = 'none'; });

      this.appendChild(card);
      if (this.data.start) this.renderState();
    }

    clearState() { while (this.state.firstChild) this.state.removeChild(this.state.firstChild); }

    renderState() {
      var self = this;
      this.clearState();
      var p = progress(this.data.start, this.data.weeks, isoToday());
      if (!p) { this.state.classList.remove('dspr-show'); return; }

      var box = el('div', 'dsn-result dsn-step-in');

      if (p.notStarted) {
        box.appendChild(el('p', 'dspr-week', 'Start in ' + p.daysUntil + (p.daysUntil === 1 ? ' Tag' : ' Tagen')));
        box.appendChild(el('p', 'dsn-text',
          'Bis dahin: Futter-Tagebuch einrichten und alle Snack-Quellen im Haushalt durchgehen, damit ab Tag 1 nichts dazwischenfunkt.'));
      } else if (p.done) {
        box.appendChild(el('p', 'dspr-week', 'Zeitraum abgeschlossen'));
        box.appendChild(el('p', 'dsn-text',
          'Alle ' + p.weeks + ' Wochen sind dokumentiert. Nimm Tagebuch und Protokoll mit in die Praxis, dort fällt die Entscheidung über die nächsten Schritte.'));
      } else {
        box.appendChild(el('p', 'dspr-week', 'Woche ' + p.week + ' von ' + p.weeks));
        var barWrap = el('div', 'dspr-bar-wrap');
        var bar = el('div', 'dsn-bar');
        var fill = el('i', '');
        fill.style.width = p.pct + '%';
        bar.appendChild(fill);
        barWrap.appendChild(bar);
        box.appendChild(barWrap);
        box.appendChild(el('p', 'dspr-meta', 'Tag ' + p.day + ' von ' + p.totalDays + ', noch ' + p.remaining + ' Tage.'));
        box.appendChild(el('p', 'dsn-text',
          'Dranbleiben heißt: nur das abgesprochene Futter, keine Snacks nebenbei, jeden Ausrutscher ehrlich ins Tagebuch. Ein einziger Kauartikel kann Wochen der Auswertung kosten.'));
      }

      var actions = el('div', 'dspr-actions');
      var printBtn = el('button', 'dsn-btn dsn-btn--ghost dsn-btn--sm', 'Stand drucken');
      printBtn.type = 'button';
      printBtn.addEventListener('click', function () { window.print(); });
      actions.appendChild(printBtn);
      var resetBtn = el('button', 'dsn-btn dsn-btn--ghost dsn-btn--sm dsn-btn--danger', 'Zurücksetzen');
      resetBtn.type = 'button';
      resetBtn.addEventListener('click', function () {
        if (!window.confirm('Protokoll-Zeitraum wirklich zurücksetzen?')) return;
        self.data = { start: '', weeks: 10 };
        self.persist();
        self.input.value = '';
        self.clearState();
        self.state.classList.remove('dspr-show');
        self.saveBtn.textContent = 'Zeitraum speichern';
        self.saveBtn.classList.remove('dsn-btn--ghost');
      });
      actions.appendChild(resetBtn);
      box.appendChild(actions);

      this.state.appendChild(box);
      this.state.classList.add('dspr-show');
    }
  }

  customElements.define('ds-nav-protokoll', DsNavProtokoll);
})();
